













import {Component, Prop, Vue} from 'vue-property-decorator';
import {ActiveInject, ActiveProvide} from "@/support/reactive"

/**
 * @status stable
 * @published 4.5.0
 * @changelog 4.5.0 Published.
 * @changelog 4.6.3 Switch to flexbox due to height problems in Safari.
 */
@Component({
    components: {}
})
export default class JdsWorkbench extends Vue {
}
